import { useState, useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { CheckCircle, XCircle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsletterUnsubscribePage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    if (!token) { setStatus("error"); return; }
    axios.post(`${API}/newsletter/unsubscribe`, { token })
      .then(({ data }) => setStatus(data.already ? "already" : "success"))
      .catch(() => setStatus("error"));
  }, [token]);

  return (
    <div className="min-h-screen bg-[#0C1620] flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <img src="/images/vmbs-logo.png" alt="VMBS" className="h-14 w-14 mx-auto mb-8 object-contain" />
        {status === "loading" && <Loader2 className="w-10 h-10 text-[#C5993A] mx-auto animate-spin" />}
        {status === "success" && (
          <div data-testid="nl-unsub-success">
            <CheckCircle className="w-14 h-14 text-[#C5993A] mx-auto mb-4" />
            <h1 className="font-heading text-2xl text-white mb-2">Abmeldung erfolgreich</h1>
            <p className="text-[#8899AA] text-sm mb-6">Sie erhalten keine weiteren Newsletter mehr.</p>
            <Link to="/"><Button className="bg-gradient-to-r from-[#C5993A] to-[#8B6B20] text-white border-0 text-sm">Zur Startseite</Button></Link>
          </div>
        )}
        {status === "already" && (
          <div>
            <CheckCircle className="w-14 h-14 text-[#8899AA] mx-auto mb-4" />
            <h1 className="font-heading text-2xl text-white mb-2">Bereits abgemeldet</h1>
            <p className="text-[#8899AA] text-sm mb-6">Sie sind bereits vom Newsletter abgemeldet.</p>
            <Link to="/"><Button className="bg-gradient-to-r from-[#C5993A] to-[#8B6B20] text-white border-0 text-sm">Zur Startseite</Button></Link>
          </div>
        )}
        {status === "error" && (
          <div>
            <XCircle className="w-14 h-14 text-red-400 mx-auto mb-4" />
            <h1 className="font-heading text-2xl text-white mb-2">Fehler</h1>
            <p className="text-[#8899AA] text-sm mb-6">Ungültiger Abmeldelink.</p>
            <Link to="/"><Button className="bg-gradient-to-r from-[#C5993A] to-[#8B6B20] text-white border-0 text-sm">Zur Startseite</Button></Link>
          </div>
        )}
      </div>
    </div>
  );
}
